module.exports = __webpack_public_path__ + "img/SGD.eee0024b.svg";